import React from "react";

interface ButtonProps {
  buttonType?:
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "filter"
    | "rent"
    | "transparent"
    | "account"
    | "gray";

  type?: "button" | "submit" | "reset";
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  buttonType = "primary",
  type = "button",
  onClick,
  disabled = false,
  className = "",
  children,
}) => {
  const buttonClasses = `
    px-4 py-2 rounded-xl outline-none focus:ring font-ubuntu
    ${
      buttonType === "primary"
        ? "bg-button text-white hover:bg-buttonHover"
        : buttonType === "secondary"
          ? "bg-secondary text-white hover:bg-secondary-dark"
          : buttonType === "filter"
            ? "bg-grayGlobal text-primary hover:bg-secondary-dark"
            : buttonType === "rent"
              ? "bg-white text-primary hover:bg-secondary-dark"
              : buttonType === "success"
                ? "bg-success text-white hover:bg-success-dark"
                : buttonType === "error"
                  ? "bg-error text-white hover:bg-error-dark"
                  : buttonType === "transparent"
                    ? "bg-transparent hover:bg-[#E8E8E8] rounded-lg text-base text-center font-medium"
                    : buttonType === "account"
                      ? "bg-primary text-white rounded-lg text-base"
                      : buttonType === "gray"
                        ? "bg-gray-200 text-primary hover:bg-gray-300 font-ubuntu font-medium"
                        : "bg-gray-200 text-gray-700 hover:bg-gray-300"
    }
    ${className} ${disabled ? "opacity-50 cursor-not-allowed" : ""}
  `;

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
